/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import { Modal397 } from '../../Modals/ModalSec3/Modal397'
import { getIrrigationSystemsByForm } from '../../../../../services/Elegibilidad/get'
import EditIcon from '@mui/icons-material/Edit'
import { useEligibility } from '../../../../../context/EligibilityContext'
import NumberFormat from 'react-number-format'
import { DeleteIrrigationSystems } from '../../../../../services/Elegibilidad/delete'
import swal from 'sweetalert'
import DeleteIcon from '@mui/icons-material/Delete'

const Table397 = ({ idElegibilityForm, tableProductionandLoss, formik }) => {
  const [state, dispatch] = useEligibility()
  const [open, setOpen] = useState(false)
  const [tableData, setTableData] = useState([])
  const [body, setBody] = useState({})
  const [Disabled, setDisabled] = useState(true)

  const getDataTable = async () => {
    try {
      const response = await getIrrigationSystemsByForm(idElegibilityForm)
      if (response.Success) {
        setTableData(response.Data)
        // if (response.Data.length === 0) {
        //   formik.setFieldValue('validTable397', true)
        // } else {
        //   const resultValidate = response.Data.filter(
        //     (obj) => obj.IdWaterSource === null,
        //   )

        //   if (resultValidate.length === 0)
        //     formik.setFieldValue('validTable397', true)
        //   else {
        //     formik.setFieldValue('validTable397', false)
        //   }
        // }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await DeleteIrrigationSystems(id)

      if (response.Success) {
        swal({
          title: 'Registro eliminado exitosamente!',
          icon: 'success',
        })
        getDataTable()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null
    ) {
      const resultArea = tableProductionandLoss.filter(
        (obj) =>
          obj.CategoryDesc === 'Agricultura orgánica' ||
          obj.CategoryDesc === 'Agroforestería (café, cacao u otros)',
      )
      if (resultArea.length > 0) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
  }, [tableProductionandLoss])

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableProductionandLoss.lenght !== 0
    ) {
      getDataTable()
    }
  }, [state.step, tableProductionandLoss])

  const columns = [
    {
      title: 'Rubro / Producto',
      field: 'Area',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Fuente de agua utilizada para el riego',
      field: 'WaterSource',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },

      align: 'center',
    },
    {
      title: 'Técnica/ Método de riego',
      field: 'IrrigationTechnique',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Área de cultivo con riego permanente (Ha)',
      field: 'PermanentIrrigationArea',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
      render: (expense) => (
        <NumberFormat
          value={expense.PermanentIrrigationArea}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            actions={[
              !Disabled
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                      >
                        Agregar registro
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                    onClick: () => {
                      setOpen(true)
                    },
                  }
                : {
                    icon: () => (
                      <Button
                        variant="contained"
                        disabled
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                      >
                        Agregar registro
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                  },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpen(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdIrrigationSystem)
                    }
                  })
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',

              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon /> }}
          />
        </Grid>
      </Grid>
      <Modal397
        open={open}
        setOpen={setOpen}
        body={body}
        setBody={setBody}
        getDataTable={getDataTable}
        idElegibilityForm={idElegibilityForm}
      />
    </div>
  )
}

export default React.memo(Table397)
